/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */

export type BoostUserSchemaRole =
  (typeof BoostUserSchemaRole)[keyof typeof BoostUserSchemaRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BoostUserSchemaRole = {
  admin: "admin",
  technician: "technician",
  admin_technician: "admin_technician",
  lead_gen: "lead_gen",
} as const;
